// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"RecentHomesHeader_headerContainer__iZY9o","header":"RecentHomesHeader_header__AtA5h"};